<template>
    <div class="tip-message">不支持移动端访问, 请使用电脑访问！</div>
</template>
<style>
.tip-message {
    text-align: center;
    padding-top: 20%;
    font-size: .5rem;
}
</style>